module.exports = __webpack_public_path__ + "img/apple_tree_set_open.720f24c0.png";